<template>
    <div class="fixing-form row">
        <div class="loaders--container" v-if="saving">
            <div class="loaders--standard"></div>
        </div>

        <div class="col-12 col-sm-6">
            <div class="form-group">
                <search-or-create-model
                    v-model="fixingData.manufacturer"

                    :label-above="true"
                    label="Manufacturer"
                    label-class="form-label"
                    :search_url="manufacturerUrl"

                    :errors="[]"
                    model_name="manufacturer"

                    :selected="manufacturer_selected"
                    @select_model="manufacturer_selected = true"
                    @unselect_model="manufacturer_selected = false"

                    :disable-create="true"
                ></search-or-create-model>
            </div>

            <div class="form-group">
                <label class="form-label" for="product_code">Product Code</label>
                <input type="text" class="form-control" id="product_code" placeholder="Enter Product Code" v-model="fixingData.product_code">
            </div>

            <div class="form-group">
                <label class="form-label" for="size">Size</label>
                <input type="text" class="form-control" id="size" placeholder="Enter Size" v-model="fixingData.size">
            </div>

            <div class="form-group">
                <search-or-create-model
                    v-model="fixingData.application"

                    :label-above="true"
                    label="Application"
                    label-class="form-label"
                    :search_url="applicationUrl"

                    :errors="[]"
                    model_name="application"

                    :selected="application_selected"
                    @select_model="application_selected = true"
                    @unselect_model="application_selected = false"

                    :disable-create="true"
                ></search-or-create-model>
            </div>

            <div class="form-group">
                <search-or-create-model
                    v-model="fixingData.purpose"

                    :label-above="true"
                    label="Purpose"
                    label-class="form-label"
                    :search_url="purposeUrl"

                    :errors="[]"
                    model_name="purpose"

                    :selected="purpose_selected"
                    @select_model="purpose_selected = true"
                    @unselect_model="purpose_selected = false"

                    :disable-create="true"
                ></search-or-create-model>
            </div>
        </div>

        <div class="col-12 col-sm-6">
            <label class="form-label">Upload Image</label>
            <div class="fixing-form--image-placeholder" v-if="fixingData.image_path == ''">
                <svg-image
                    class="fixing-form--image-placeholder--image"
                    :src="`/svg/${resource_group}/fixing-placeholder.svg`"
                    width="40px"
                    height="40px"
                    color="primary"
                ></svg-image>
            </div>
            <div v-else>
                <img class="img-fluid" :src="getImage" alt="">
            </div>
            <upload-image-button
                v-model="fixingData.image_path"
                class="fixing-form--upload"
                button_class="btn btn-success"
                :label="fixingData.image ? 'Change Image' : 'Upload Image'"
                @file="fixingData.image = $event"
            ></upload-image-button>
        </div>

        <div class="col-12 text-right">
            <button @click="save()" class="btn btn-primary">Save</button>
        </div>
    </div>
</template>

<script>
    import SearchOrCreateModel from "../../general_components/SearchOrCreateModel";
    import UploadImageButton from "../../general_components/UploadImageButton";
    export default {
        name: "FixingCreateEditPage",
        components: {UploadImageButton, SearchOrCreateModel},
        props: {
            method: {
                type: String,
                default: 'post'
            },
            submitUrl: {
                type: String,
                required: true
            },
            fixing: {
                type: Object,
                default: () => { return {} }
            },
            manufacturerUrl: {
                type: String,
                required: true
            },
            applicationUrl: {
                type: String,
                required: true
            },
            purposeUrl: {
                type: String,
                required: true
            },
            backUrl: {
                type: String,
                required: true
            }
        },

        data(){
            return {
                fixingData: {
                    product_code: '',
                    size: '',
                    image_path: '',

                    manufacturer: {},
                    application: {},
                    purpose: {},

                    image: ''
                },

                manufacturer_selected: false,
                application_selected: false,
                purpose_selected: false,

                saving: false,

                errors: []
            }
        },

        beforeMount() {
            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);

            this.fixingData = {...this.fixingData, ...this.fixing};

            this.manufacturer_selected = this.fixingData.manufacturer.id !== undefined ? this.fixingData.manufacturer.id : false;
            this.application_selected = this.fixingData.application.id !== undefined ? this.fixingData.application.id : false;
            this.purpose_selected = this.fixingData.purpose.id !== undefined ? this.fixingData.purpose.id : false;
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                //as uploading an image formData should be used
                let formData = new FormData();

                formData.append('_method', this.method);

                Object.keys(this.fixingData).forEach((key) => {
                    if((typeof this.fixingData[key] === 'object') && this.fixingData[key] !== null && !(this.fixingData[key].type && this.fixingData[key].type.indexOf('image') !== -1)){
                        Object.keys(this.fixingData[key]).forEach((innerKey) => {
                            formData.append(`${key}[${innerKey}]`, this.fixingData[key][innerKey]);
                        });
                        return;
                    }
                    formData.append(key, this.fixingData[key]);
                })

                axios.post(this.submitUrl, formData, {
                    headers: {
                        'Content-Type' : 'multipart/form-data',
                        'Accept' : 'application/json'
                    }
                }).then((response) => {
                    this.saving = false;
                    window.location.href = response.data.url;
                }).catch((error) => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },

            cancel: function(){
                window.location.href = this.backUrl;
            },
        },

        computed: {
            getImage: function(){
                return this.fixingData.image_path === null || (this.fixingData.image_path.indexOf('data:image') === -1 && this.fixingData.full_path !== undefined)
                        ? this.fixingData.full_path
                        : this.fixingData.image_path;
            }
        }
    }
</script>
